var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlechadesactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.255 7.35731C18.1984 7.24961 18.1135 7.15941 18.0094 7.09644C17.9053 7.03347 17.786 7.00013 17.6644 7H5.6652C5.54377 7.0005 5.42477 7.0341 5.32101 7.09717C5.21724 7.16024 5.13263 7.25041 5.07628 7.35797C5.01993 7.46553 4.99396 7.58642 5.00118 7.70764C5.0084 7.82885 5.04852 7.94581 5.11723 8.04593L11.1168 16.712C11.178 16.8008 11.2598 16.8734 11.3553 16.9236C11.4507 16.9738 11.5569 17 11.6648 17C11.7726 17 11.8788 16.9738 11.9743 16.9236C12.0698 16.8734 12.1516 16.8008 12.2127 16.712L18.2123 8.04593C18.2817 7.94602 18.3224 7.82899 18.3299 7.70758C18.3374 7.58617 18.3115 7.46502 18.255 7.35731ZM11.6648 15.1614L6.93711 8.33324H16.3925L11.6648 15.1614Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechadesactive);
export default __webpack_public_path__ + "static/media/flechadesactive.c49976a9166938abd0cd9b986ef7ffeb.svg";
export { ForwardRef as ReactComponent };